import Menu from "../Menu.js";
import ConfirmationArea from "./ConfirmationArea.js";
import global from "../global.js";

// const log = global.log.getLogger("f_mtac.ui.GraphicsUpdateArea");

/**
 * @brief Menu that opens when we click on a graphic (disk, line, arrow).
 */
const GraphicsUpdateArea = function () {
    var tools = global.tools;
    var scene = global.scene; // Common rule_set making the manipulation of CSS easier through multiple files.
    var selected = null;

    let unselect = () => {
        if (selected === null) {
            return;
        }
        // The first iteration is used to find if the HTML element have the correct class, then we modify local style.
        for (var i = 0; i < $(selected.handle.node()).children(":nth-child(1)")[0].children.length; i++) {
            if ($(selected.handle.node()).children(":nth-child(1)")[0].children[i].className.baseVal == "distance_group") {
                {
                    scene.style.rule_set(
                        `${selected.handle.property("id")}_visibility`,
                        `
                #${selected.handle.property("id")} g.distance_group {visibility: hidden}
            `
                    );
                    break;
                }
            }
        }
        scene.shadow.unaffect(selected.handle);
        selected = null;
    };

    let select = (node) => {
        if (selected !== null) {
            unselect();
        }
        selected = scene.objects.get_by_node("scene", node);
        scene.shadow.affect(selected.handle);
    };

    Object.defineProperty(this, "selected", {
        set: () => {},
        get: () => selected
    });

    this.select = async (handle) => {
        if (scene.mode_switcher.mode !== "graphics") {
            return;
        }
        await Menu.close("graphics_update_area");
        select(handle);
        let color_value = $(selected.handle.node()).children(":nth-child(1)").find("[stroke]").attr("stroke");
        if (color_value in scene.color_by_value) {
            if (global.storage.selected_context.projection.project !== null) {
                // The first iteration is used to find if the HTML element have the correct class, then we modify local style.
                for (var i = 0; i < $(selected.handle.node()).children(":nth-child(1)")[0].children.length; i++) {
                    if ($(selected.handle.node()).children(":nth-child(1)")[0].children[i].className.baseVal == "distance_group") {
                        {
                            scene.style.rule_set(
                                `${selected.handle.property("id")}_visibility`,
                                `
                    #${selected.handle.property("id")} g.distance_group {visibility: visible}
                `
                            );
                            break;
                        }
                    }
                }
            }
            let color = scene.color_by_value[color_value];
            // The graphics_color_update seems to be mandatory for the Menu to work.
            tools.group_select("graphics_colors_update", `graphics_color_update${color.name}`);
        }
        await Menu.display(["graphics_update_area"]);
    };

    this.init = function () {
        tools = global.tools;
        scene = global.scene;

        Menu.create({
            name: "graphics_update_area",
            icon: "graphics",
            contents: ["graphics_colors_update", "graphic_duplicate", "graphic_delete"],
            open_handler: () => {
                scene.disable_draggable_tools();
            },
            close_handler: () => {
                if (scene.objects.layers.media.ids.length > 0) {
                    scene.enable_draggable_tools();
                }
                unselect();
            },
            close_timer: true
        });

        tools.register({
            name: "duplicate_graphic",
            icon: "duplicate f_mtac-icon-xlg",
            position: "#graphic_duplicate",
            handler: async () => {
                let old_object = selected;
                let new_object = scene.objects.duplicate("scene", old_object);
                let angle = Math.random() * 2 * Math.PI;
                new_object.move({
                    x: (50 * Math.cos(angle)) / scene.root_transform.k,
                    y: (50 * Math.sin(angle)) / scene.root_transform.k
                });
                await scene.objects.publish("scene", new_object);
                this.select(new_object.handle.node());
            }
        });

        tools.register({
            name: "delete_graphic",
            icon: "suppp f_mtac-icon-xlg",
            position: "#graphic_delete",
            handler: async () => {
                ConfirmationArea.interact({
                    title: global.internationalization.text("global.Warning"),
                    tip1: global.internationalization.text("drawing.Delete-drawing")
                }).then((confirmed) => {
                    if (!confirmed) {
                        return;
                    }
                    let object = selected;
                    scene.objects.tx_delete("scene", object);
                    Menu.close("graphics_update_area");
                });
            }
        });

        tools.register_group({
            name: "graphics_colors_update",
            target: "$none",
            enable: (_, selected_tool) => {
                let object = selected;
                let color = selected_tool.data.color.value;
                scene.object_color(object, color);
                scene.objects.tx_update("scene", object);
            },
            disable: () => {}
        });
        scene.colors.forEach((color) => {
            tools.register({
                group: "graphics_colors_update",
                name: `graphics_color_update${color.name}`,
                data: {color},
                icon: "drop_black",
                position: "#graphics_colors_update",
                style: {color: color.value, "text-stroke": "1px #fff"}
            });
        });
    };

    window.addEventListener("f_mtac.init", () => {
        this.init();
    });
};

export default new GraphicsUpdateArea();
